import { Col, Row } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useStores } from '../../../../../hooks';
import { SearchBar } from '../../../../../components/mui/searchBar';
import { CombinedItem, GetCombinedItemQuery } from '../../../../../core/models';
import { COMBINED_ITEMS_AUTO_COMPLETE_SEARCH_SIZE } from '../../../../../store';

interface PageProps {
    value?: GetCombinedItemQuery;
    onChange: (value: GetCombinedItemQuery) => void;
    searchItems: (query: GetCombinedItemQuery) => Promise<void>;
    searchItemsForAutoComplete?: (query: GetCombinedItemQuery) => Promise<CombinedItem[]>;
}

export const CombinedItemSearchPanel = observer(function CombinedItemSearchPanelComponent(props: PageProps) {
    const {
        domain: { constantsStore },
    } = useStores();

    const { value, onChange, searchItems, searchItemsForAutoComplete } = props;

    useEffect(() => {
        if (!constantsStore.isLoading) {
            search({ silent: true });
        }
    }, [constantsStore.isLoading]);

    const isValidSearch = (value?: string, options?: { silent: boolean }) => {
        return true;
    };

    const search = async (options?: { silent: boolean }) => {
        if (!isValidSearch(value?.description, options)) {
            return;
        }

        await searchItems(value as GetCombinedItemQuery);
    };

    const updateFilter = (searchValue: string) => {
        const value = searchValue?.trim();
        const query: GetCombinedItemQuery = {
            description: value,
            pimsId: value,
        };

        onChange(query);
    };

    const requestAutoComplete = async (searchValue: string) => {
        const value = searchValue?.trim();
        const query: GetCombinedItemQuery = {
            description: value,
            pimsId: value,
            size: COMBINED_ITEMS_AUTO_COMPLETE_SEARCH_SIZE,
        };

        const items = (await searchItemsForAutoComplete?.(query)) || [];
        return items.reduce((agg, item) => {
            if (item.description && !agg.includes(item.description)) {
                agg.push(item.description);
            }

            if (item.pimsId && !agg.includes(item.pimsId)) {
                agg.push(item.pimsId);
            }

            return agg;
        }, [] as string[]);
    };

    return (
        <>
            <Row>
                <Col xs={12}>
                    <SearchBar
                        disabled={constantsStore.isLoading}
                        isSelfControlled={false}
                        value={value?.description}
                        onChange={updateFilter}
                        onSubmit={() => search()}
                        searchItemsForAutoComplete={requestAutoComplete}
                    />
                </Col>
            </Row>
        </>
    );
});
